import { useBaseContext } from "context/base"
import { useReducer } from "react"
import { popUpWindow } from "util/global"

/**
 * @typedef {Object} ListTugasState
 * @property {BaseSelectFormatData} selectedFilter - The selected tugas filter.
 * @property {Array<BaseSelectFormatData>} optionsFilter - The options for the tugas filter.
 * @property {Array} data - The list of contents tugas data.
 * @property {Object} meta - Metadata related to pagination and filtering.
 * @property {boolean} loading - Indicates if the data is currently being loaded.
*/

/**
 * @typedef {Object} Action
 * @property {'set_meta' | string} [type] - The type of action to perform.
 * @property {any} payload - The payload containing the data to update the state.
 */

/**
 * List Contents  Reducer
 * @param {ListTugasState} state - The current state of the contents tugas list.
 * @param {Action} action - The action to perform on the state.
 * @returns {ListTugasState} The updated state.
 */
const listTugasReducer = (state, action) => {
  switch (action.type) {
    case 'set_meta':
      return {
        ...state,
        meta: {
          ...state.meta,
          ...action.payload
        }
      }
    default:
      return {
        ...state,
        ...action.payload,
      }
  }
}

export function useTugasHook() {
  const { getRequest } = useBaseContext()

  /**
   * @type {[ListTugasState, (params: Action) => void]}
  */
  const [listTugas, dispatchListTugas] = useReducer(listTugasReducer, {
    selectedFilter: null,
    optionsFilter: [],
    errorMessage: '',
    data: [],
    meta: {
      search: '',
      limit: 10,
      offset: 0,
      totalData: 0,
    },
    loading: false,
  })

  /**
   * Get Tugas Handler
   * 
   * @param {{
   *  setInitSelectValue: (listOptions: Array<BaseSelectFormatData>) => void
   * }} getTugasParams 
   */
  const getTugasHandler = async (getTugasParams) => {
    dispatchListTugas({ payload: { loading: true } })
    const response = await getRequest('assignment?isTitleOnly=true')
    if (response) {
      dispatchListTugas({ payload: { loading: false } })

      const options = response?.data?.map((item) => ({
        value: item.id,
        label: item.title,
      }))

      const responseData = {
        ...listTugas,
        optionsFilter: options,
        data: response?.data,
        meta: {
          ...listTugas.meta,
          ...response.meta
        },
        loading: false,
      }

      if (getTugasParams?.setInitSelectValue && typeof getTugasParams?.setInitSelectValue === 'function') {
        getTugasParams.setInitSelectValue(options)
      }
      dispatchListTugas({ payload: responseData })
    } else {
      dispatchListTugas({ payload: { loading: false } })
    }
  }

  const popUpWindowKelolaTugasHandler = () => popUpWindow('/kelola-assignment/add?popup=true', window, 800, 600)

  return {
    data: {
      listTugas,
    },
    dispatch: {
      dispatchListTugas,
    },
    handler: {
      getTugasHandler,
      popUpWindowKelolaTugasHandler,
    }
  }
}